'use client';

import type {
  CampaignPlacement,
  Device,
  ProductType,
  SessionId,
  USAStateAcronym,
  ZipCode,
} from '@hc-frontend/core-types';
import type { FeaturedAds } from '@hc-frontend/core-types';
import { Placement } from '@hc-frontend/core-types';
import { useEventBus, useTrackingContexts } from '@hc-frontend/core-ui';
import type { SendMetricEventTarget } from '@hc-frontend/shells-shared';
import { useEffect } from 'react';

import type { AdImpressionEvent } from '../../atoms/ad-events-subscription';

type StickyBannerAdTrackImpressionProps = {
  ads: FeaturedAds;
  productType: ProductType;
  campaignPlacement: CampaignPlacement;
  sessionId: SessionId;
  device: Device;
  stateAcronym: USAStateAcronym;
  zipCode: ZipCode;
};

export function StickyBannerAdTrackImpression({
  ads,
  campaignPlacement,
  productType,
  device,
  sessionId,
  stateAcronym,
  zipCode,
}: StickyBannerAdTrackImpressionProps) {
  const eventBus = useEventBus();
  const contexts = useTrackingContexts();

  useEffect(() => {
    eventBus.publish<AdImpressionEvent, SendMetricEventTarget>({
      topic: 'core.ui.ad.impression',
      adsSource: 'FeaturedAds',
      featuredAds: ads,
      id: '',
      campaignPlacement,
      placement: Placement.enum.TYP,
      productType,
      source: '',
      contexts,
      device,
      sessionId,
      stateAcronym,
      zipCode,
      domain: window.location.hostname.replace(/(qa|stg|local)\./g, ''),
    });
  }, [
    ads,
    campaignPlacement,
    contexts,
    device,
    eventBus,
    productType,
    sessionId,
    stateAcronym,
    zipCode,
  ]);

  return null;
}
